import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as ExperiencesActions from "../../actions/experiencesActions";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";

const loadExperiencesLogic = createLogic({
	type: ActionTypes.LOAD_EXPERIENCES,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(ControlPanelActions.showLoading());

		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.get(`/apps/${action.appKey}/experiences`)
					.then(res => {
						dispatch(ControlPanelActions.hideLoading());
						dispatch(ExperiencesActions.loadExperiencesSuccess(res.data));
						done();
					})
					.catch(error => {
						dispatch(ControlPanelActions.hideLoading());
						dispatch(ExperiencesActions.loadExperiencesFail(error));
						done();
					});
			});
	},
});

export default [loadExperiencesLogic];
